class Plugin {
    createReducer() {
        return false;
    }
    /*
    * Allow to override passed in configurations
    */
    beforeConfig(config) {
        return config;
    }
    /*
    * This method is called on initialization
    */
    init(view, appState, dispatch) {
        return;
    }
    /*
    * This method is called on each state update
    */
    update(view, appState, dispatch) {
        return;
    }
    /*
    * This method is called on instance unmounting
    */
    unmount(view, appState, dispatch) {
        return;
    }
}
export default Plugin;
